import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import CreateModal, { CreateModalProps } from "./index";

interface AiSupportedTasksCreateModalProps
  extends Omit<CreateModalProps, "onSubmit"> {
  onSubmit: (input: any) => Promise<void>;
}

export const AiSupportedTasksCreateModal: React.FC<
  AiSupportedTasksCreateModalProps
> = ({ onSubmit, initialInput, ...props }) => {
  const { t } = useTranslation();

  const [context, setContext] = useState("");

  const handleSubmit = async (input: any) => {
    // Prepare submission data with AI-supported tasks-specific fields
    let submissionData = {
      ...input,
    };

    // Handle context field (combine with prompt for AI modals)
    if (context?.trim()) {
      submissionData.prompt = `${input.prompt}\n\nBağlam: ${context}`;
    }

    await onSubmit(submissionData);
  };

  const AiSupportedTasksSpecificFields = () => (
    <div className="space-y-6">
      {/* Context Field */}
      <div className="space-y-2">
        <label className="inline-block text-sm font-medium text-teal-700 dark:text-teal-300">
          {t("aiSupported.form.context")}
        </label>
        <textarea
          value={context}
          onChange={(e) => setContext(e.target.value)}
          className="w-full rounded-xl border-2 border-gray-200 dark:border-gray-700 p-4 text-base focus:ring-2 focus:ring-teal-500 focus:border-transparent dark:bg-gray-700/50 transition-all duration-200"
          rows={3}
          placeholder={t("aiSupported.form.contextPlaceholder")}
        />
      </div>
    </div>
  );

  return (
    <CreateModal
      {...props}
      themeColor="teal"
      onSubmit={handleSubmit}
      initialInput={initialInput}
      after={<AiSupportedTasksSpecificFields />}
    />
  );
};

export default AiSupportedTasksCreateModal;
